import { useMemo } from "react";
import { defaultYAxisConfig } from "src/components/ScoringChart/BaseChartStyle";

export default function useYAxisConfig(chartData, selector, itemSelector, yAxisArrayConfig = []) {
  return useMemo(() => {
    const yAxisConfig = [];
    const _len = yAxisArrayConfig.length;
    var counter = -1;
    try {
      for (var item of chartData) {
        counter += 1;
        const data = selector(item);
        let minValue = itemSelector(data[0]);
        let maxValue = 0;
        for (var dataItem of data) {
          const _dataTemp = itemSelector(dataItem);
          if (minValue > _dataTemp) minValue = _dataTemp;
          if (maxValue < _dataTemp) maxValue = _dataTemp;
        }
        if (_len > counter)
          yAxisConfig.push({
            ...yAxisArrayConfig[counter],
            ...{ min: minValue, max: maxValue, gridLineWidth: 0, label: { enabled: true } },
          });
        else yAxisConfig.push({ ...defaultYAxisConfig, ...{ min: minValue, max: maxValue } });
      }
    } catch (error) {
      yAxisConfig.push({ ...defaultYAxisConfig });
    }
    return yAxisConfig;
  }, [chartData]);
}
